import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TTL_MS = 30000;
let cache = null; // { token, at, promise, data }

function loadOwned(token) {
  if (cache && cache.token === token && Date.now() - cache.at < TTL_MS) return cache.promise;
  const entry = { token, at: Date.now(), data: cache?.token === token ? cache.data : null };
  entry.promise = axios
    .get(`${API}/enrollment/owned`, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => { entry.data = r.data || {}; return entry.data; })
    .catch(() => ({}));
  cache = entry;
  return entry.promise;
}

// Returns isBought(type, item): true when a paid item is already owned by the logged-in user.
export function useOwnedContent() {
  const token = localStorage.getItem('token');
  const [owned, setOwned] = useState(() => (cache?.token === token && cache?.data) || {});

  useEffect(() => {
    if (!token) { setOwned({}); return undefined; }
    let alive = true;
    loadOwned(token).then((d) => { if (alive) setOwned(d); });
    return () => { alive = false; };
  }, [token]);

  return useCallback(
    (type, item) => !!item && !item.is_free && Number(item.price) > 0 && !!owned[type]?.includes(item.id),
    [owned]
  );
}
